<p>events-mld works!</p>
<app-navbar></app-navbar>

<section class="blog-area ptb-100">
  <div class="container">
    <h3 class="widget-title" style="color: #ffffff; text-align: center">
      21st February International Mother Language Day Observation 2023
    </h3>
    <hr />
    <div>
      <p style="color: white;">
        21st February 2023 <br />
        <br />
        Homage to the Language martyrs who sacrificed for the basic human rights
        thereby setting foundation for our liberation consequent to victory.
      </p>
      <section class="blog-area gallery-section">
        <div class="container">
          <div class="container">
            <div class="gallery-container">
              <div class="gallery">
                <a
                  *ngFor="let image of images"
                  class="gallery__item"
                  href="{{ image.src }}"
                  [title]="image.alt"
                >
                  <img
                    [src]="image.thumbnail"
                    [alt]="image.alt"
                    class="popup-btn"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>
